import React from "react";
import { motion } from "framer-motion";
import { Box, Container, Paper, Typography } from "@mui/material";
import { FaDesktop, FaUserCheck, FaEye, FaHandshake } from "react-icons/fa";
import { useTranslation } from "react-i18next";

export default function IconosInformativos() {
  const { t } = useTranslation();

  const stats = [
    { icon: <FaDesktop size={28} />, key: "item1" },
    { icon: <FaUserCheck size={28} />, key: "item2" },
    { icon: <FaEye size={28} />, key: "item3" },
    { icon: <FaHandshake size={28} />, key: "item4" },
  ];

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 8, md: 12 },
        bgcolor: "#f8fafc",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Container
        maxWidth="xl"
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 4,
            alignItems: "stretch",
            justifyContent: "center",
          }}
        >
          {stats.map((stat, idx) => (
            <Box
              key={idx}
              sx={{
                width: {
                  xs: "100%",
                  sm: "calc(50% - 16px)",
                  md: "calc(25% - 24px)",
                },
                display: "flex",
                minWidth: 0,
              }}
            >
              <Paper
                component={motion.div}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{
                  duration: 0.5,
                  delay: 0.4 + idx * 0.1,
                }}
                whileHover={{ y: -6 }}
                elevation={0}
                sx={{
                  width: "100%",
                  p: 4,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                  borderRadius: "20px",
                  border: "1px solid #f1f5f9",
                  bgcolor: "#ffffff",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
                  transition: "all .3s ease",

                  "&:hover": {
                    boxShadow:
                      "0 20px 25px -5px rgba(104,168,222,0.15)",
                    borderColor: "rgba(104,168,222,0.3)",

                    "& .icon-wrapper": {
                      transform: "scale(1.1)",
                    },
                  },
                }}
              >
                <Box
                  className="icon-wrapper"
                  sx={{
                    width: 64,
                    height: 64,
                    borderRadius: "16px",
                    mb: 3,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bgcolor: "rgba(104,168,222,0.10)",
                    color: "#68a8de",
                    transition: "transform .3s ease",
                    flexShrink: 0,
                  }}
                >
                  {stat.icon}
                </Box>

                <Typography
                  sx={{
                    color: "#1e293b",
                    fontWeight: 500,
                    lineHeight: 1.5,
                    fontSize: "1rem",
                  }}
                >
                  {t(`iconos_informativos.${stat.key}`)}
                </Typography>
              </Paper>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}